import { render, staticRenderFns } from "./theHeader.vue?vue&type=template&id=c9a0baf4&scoped=true"
import script from "./theHeader.vue?vue&type=script&lang=js"
export * from "./theHeader.vue?vue&type=script&lang=js"
import style0 from "./theHeader.vue?vue&type=style&index=0&id=c9a0baf4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a0baf4",
  null
  
)

export default component.exports